


































































import {Component, Vue} from 'vue-property-decorator';
import {Area} from "@/types";
import {addArea, deleteArea, getAreaList, searchByArea} from "@/endpoints";
import Search from "../utility/Search.vue";
import {serializeForm} from "@/util";

//Vue.component("v-search", Search);
Vue.component("v-search", Search);

@Component
export default class Areas extends Vue {

    SearchByArea = searchByArea;

    availableAreas: Area[] = [];

    areaToBeDeleted: any = null;

    loadingAreas: boolean = false;
    submitted: boolean = false;

    addAreaForm: {
        name: string;
    } = {
        name: ""
    };

    mounted() {
        this.refreshAreaList();
    }

    onSearchAreaFilterInput(result) {
        this.refreshAreaList(result ? result.id : null);
    }

    async refreshAreaList(id?: number) {
        this.loadingAreas = true;

        const params = new URLSearchParams();

        if(id) {
            params.append("id", `${id}`);
        }

        this.availableAreas = await getAreaList(params.toString());

        this.loadingAreas = false;
    }

    onDeleteAreaButtonClick(area) {
        this.areaToBeDeleted = area;
        (this.$refs["delete-area-modal"] as any).show();
    }

    async onConfirmAreaDeletion() {
        this.submitted = true;
        this.availableAreas = await deleteArea(this.areaToBeDeleted.id);
        this.submitted = false;
        (this.$refs["delete-area-modal"] as any).hide();
    }

    onAddAreaModalHidden() {
        this.addAreaForm.name = "";
    }

    async onAddAreaSubmitButtonClick() {

        this.submitted = true;

        const payload = JSON.stringify(serializeForm(this.$refs['add-area-form'] as HTMLFormElement));

        try {
            await addArea(payload);

            this.refreshAreaList();

            (this.$refs['add-area-modal'] as any).hide();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    get isValidAreaName() {
        return this.addAreaForm.name.length > 0;
    }

}
